import request from '@/utils/request'

export function getChargeAccountTypeTree(obj) {
  return request({
    url: `/api/finance/account/type/tree`,
    method: 'get',
    params: {...obj, name: '123'}
  })
}
export function addChargeAccountType(obj) {
  return request({
    url: `/api/finance/account/type`,
    method: 'post',
    data: obj
  })
}

export function deleteChargeAccountType(id) {
  return request({
    url: `/api/finance/account/type/${id}`,
    method: 'delete'
  })
}

export function getChargeAccountType(id) {
  return request({
    url: `/api/finance/account/type/${id}`,
  })
}

export function updateChargeAccountType(obj) {
  return request({
    url: `/api/finance/account/type`,
    method: 'put',
    data: obj
  })
}
